import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  flags = 'flags',
  resolverTest = 'resolverTest',
  flag = 'flag',
  flagsTools = 'flagsTools',
}

enum ExternalRoutesIds {
  workflow = 'workflow',
  workflowInstance = 'workflowInstance',
  clients = 'clients',
  clientSchema = 'clientSchema',
  client = 'client',
  materializedSegments = 'materializedSegments',
  materializedSegment = 'materializedSegment',
  materializedSegmentLoadJob = 'materializedSegmentLoadJob',
  segments = 'segments',
  segment = 'segment',
  labels = 'labels',
  github = 'github',
}

// root route
export const flagsRouteRef = createRouteRef({ id: RoutesIds.flags });

export const rootRouteRef = flagsRouteRef;

// sub-routes within the plugin
export const resolverTesterRouteRef = createSubRouteRef({
  id: RoutesIds.resolverTest,
  parent: rootRouteRef,
  path: '/resolver-test',
});

export const flagRouteRef = createSubRouteRef({
  id: RoutesIds.flag,
  parent: rootRouteRef,
  path: '/:id',
});

export const flagsToolsRouteRef = createSubRouteRef({
  id: RoutesIds.flagsTools,
  parent: rootRouteRef,
  path: '/tools',
});

// external routes to other plugins
export const workflowRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.workflow,
  params: ['workflow'],
  optional: true,
});

export const workflowInstanceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.workflowInstance,
  params: ['workflow', 'id'],
  optional: true,
});

export const clientsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.clients,
  optional: true,
});

export const clientSchemaRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.clientSchema,
  optional: true,
});

export const clientRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.client,
  params: ['id'],
  optional: true,
});

// Segments routes as Segments and materialized segments components still lives in
// flags plugin. Once we migrate these components to the new modules,
// we can remove these routes.
export const materializedSegmentsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.materializedSegments,
});

export const materializedSegmentRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.materializedSegment,
  params: ['id'],
});

export const materializedSegmentLoadJobRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.materializedSegmentLoadJob,
  params: ['id'],
});

export const segmentsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.segments,
});

export const segmentRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.segment,
  params: ['id'],
});

export const labelsRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.labels,
  optional: true,
});

export const githubRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.github,
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  flags: flagsRouteRef,
  resolverTest: resolverTesterRouteRef,
  flag: flagRouteRef,
  flagsTools: flagsToolsRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other plugins
  workflow: workflowRouteRef,
  workflowInstance: workflowInstanceRouteRef,
  clients: clientsRouteRef,
  clientSchema: clientSchemaRouteRef,
  client: clientRouteRef,
  materializedSegments: materializedSegmentsRouteRef,
  materializedSegment: materializedSegmentRouteRef,
  materializedSegmentLoadJob: materializedSegmentLoadJobRouteRef,
  segments: segmentsRouteRef,
  segment: segmentRouteRef,
  labels: labelsRouteRef,
  github: githubRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
